import { render, staticRenderFns } from "./mainTitle.vue?vue&type=template&id=65cdb700&scoped=true&"
import script from "./mainTitle.vue?vue&type=script&lang=js&"
export * from "./mainTitle.vue?vue&type=script&lang=js&"
import style0 from "./mainTitle.vue?vue&type=style&index=0&id=65cdb700&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cdb700",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("K:\\website\\tmp\\2021.7-12\\mmlzcyy_project\\screen\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65cdb700')) {
      api.createRecord('65cdb700', component.options)
    } else {
      api.reload('65cdb700', component.options)
    }
    module.hot.accept("./mainTitle.vue?vue&type=template&id=65cdb700&scoped=true&", function () {
      api.rerender('65cdb700', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/mainTitle.vue"
export default component.exports